angular.module('FlexyBeautyApp.services')
    .factory('StoreAppCode', [function () {
        return {
            OPTION_START_APP_CODE: "start",
            OPTION_PLUS_APP_CODE: "plus",
            OPTION_BOOST_APP_CODE: "boost",
            OPTION_PRESTIGE_APP_CODE: "prestige",
            OPTION_ANNUAL_APP_CODE: "annual",
            OPTION_ONLINE_SHOP_APP_CODE: "onlineShop",
            OPTION_SOLO_APP_CODE: "solo",
            OPTION_GIFT_ITEM_APP_CODE: "giftItem",
            OPTION_LOYALTY_CARD_APP_CODE: "loyaltyCard",
            OPTION_ONLINE_BOOKING_APP_CODE: "onlineBooking",
            OPTION_POS_APP_CODE: "pos",
            OPTION_ICAL_APP_CODE: "ical",
            OPTION_CURE_APP_CODE: "cure",
            OPTION_NATIVE_APP_APP_CODE: "nativeApp",
            OPTION_BOOKING_SMS_SECURITY_APP_CODE: "bookingSmsSecurity",
            OPTION_SMS_REMINDER_APP_CODE: "smsReminder",
            OPTION_SMS_CAMPAIGN_APP_CODE: "smsCampaign",
            OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE: "optionReserveWithGoogle",
            OPTION_LE_CISEAU_STORE_APP_CODE: "optionLeCiseau",
            OPTION_LE_CISEAU_LIGHT_STORE_APP_CODE: "optionLeCiseauLight",
            OPTION_WITHOUT_TILL_STORE_APP_CODE: "withoutTill",
            OPTION_WEBSITE: "website",
            OPTION_WEBSITE_PAYMENT: "websitePayment",
            OPTION_CLIENT_FULL: "clientFull",
            OPTION_STATISTICS: "statistics",
            OPTION_STATISTICS_FULL: "statisticsFull",
            OPTION_BOOKSY_BUTTON: "booksyMigration",
        };
    }])
    .factory('StoreAppObject', ['StoreAppCode', function () {
        const StoreAppObject = function (storeAppCode) {
            this.code = storeAppCode;
        };
        StoreAppObject.prototype.onSubscriptionChange = function () {
            return Promise.resolve(true);
        };
        StoreAppObject.prototype.computeSubscriptionChangeDescriptionMessage = function () {
            return null;
        };
        StoreAppObject.prototype.afterSubscriptionChange = function (subscriptionView) {
            //by default nothing to do
        };
        StoreAppObject.prototype.displaySubscription = function (companyView, subscriptionView) {
            return true;
        };
        StoreAppObject.prototype.disableSubscription = function (offerCode) {
            return false;
        };

        return StoreAppObject;
    }])
    .factory('StoreAppCodeFactory', ['StoreAppCode', 'StoreAppObject', 'gettextCatalog', 'AppData', '$dialog', 'CompanySrv',
        'AppCode', 'BasicAuthRole', 'Countries', 'OfferManager', 'CompanyType', "UserSrv", "Brand", "Offers",
        function (StoreAppCode, StoreAppObject, gettextCatalog, AppData, $dialog, CompanySrv,
                  AppCode, BasicAuthRole, Countries, OfferManager, CompanyType, UserSrv, Brand, Offers) {
            let storeAppCodeFactory;
            let storeAppCodeObjects = {};

            for (let storeAppCode in StoreAppCode) {
                if (StoreAppCode.hasOwnProperty(storeAppCode)) {
                    storeAppCodeObjects[StoreAppCode[storeAppCode]] = new StoreAppObject(StoreAppCode[storeAppCode]);
                }
            }
            let onIcalSubscriptionChange = function (subscriptionView) {
                let question = gettextCatalog.getString("Êtes-vous sûr de vouloir désactiver l’option {{optionName}} ? (L’option ne pourra pas être réactivée.)",
                    {optionName: subscriptionView.storeAppView.label});
                let opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/generalConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            let tableModel = [];
                            tableModel["question"] = question;
                            return tableModel;
                        }
                    }
                };

                let d = $dialog.dialog(opts);

                return d.open();
            }

            let onPartnerSubscriptionChange = function (subscriptionView) {
                let question;
                let description;

                if (!subscriptionView.isActive) {
                    question = gettextCatalog.getString("Êtes-vous sûr de vouloir désactiver l’option {{optionName}} ? (L’option pourra être réactivée. Attention cette réactivation peut prendre jusqu'à 24h).",
                        {optionName: subscriptionView.storeAppView.label});
                } else {
                    question = gettextCatalog.getString("Êtes-vous sûr de vouloir activer l’option {{optionName}} ? (L'activation peut prendre jusqu'à 24h).",
                        {optionName: subscriptionView.storeAppView.label});
                    description = this.computeSubscriptionChangeDescriptionMessage();
                }

                let opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/generalConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            let tableModel = [];
                            tableModel["question"] = question;
                            tableModel["description"] = description;
                            return tableModel;
                        }
                    }
                };

                let d = $dialog.dialog(opts);

                return d.open();
            };

            let onMarketPlaceSubscriptionChange = function (subscriptionView, companyView, user) {
                return new Promise((resolve, reject) => {
                    if (!subscriptionView.isActive) {
                        return resolve(true);
                    }
                    let marketPlaceLabel = BasicAuthRole.LE_CISEAU_ROLE.label;
                    let opts = {
                        backdrop: true,
                        keyboard: false,
                        backdropClick: false,
                        templateUrl: '/partials/global/marketPlaceContactDialog.html',
                        dialogClass: "modal modal-sm",
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["marketPlaceLabel"] = marketPlaceLabel;
                                tableModel["buttonLabel"] = gettextCatalog.getString("Activer la synchronisation avec {{marketPlaceLabel}}", {marketPlaceLabel: marketPlaceLabel});
                                return tableModel;
                            }
                        }
                    };
                    let dialog = $dialog.dialog(opts);
                    dialog.open().then(function (result) {
                        if (!result) {
                            return reject();
                        } else {
                            UserSrv.notifyMarketPlace(user.id);
                            companyView.openLinkInFrame(Brand.url.subscribeSSO, user.email);
                            return resolve(true);
                        }
                    });
                });
            }
            storeAppCodeObjects[StoreAppCode.OPTION_ICAL_APP_CODE].onSubscriptionChange = onIcalSubscriptionChange;
            storeAppCodeObjects[StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE].onSubscriptionChange = onPartnerSubscriptionChange;
            storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].onSubscriptionChange = onMarketPlaceSubscriptionChange;
            storeAppCodeObjects[StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE].afterSubscriptionChange = function (subscriptionView) {
                if (!subscriptionView.isActive) {
                    CompanySrv.disableRwg();
                }
            };

            storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].computeSubscriptionChangeDescriptionMessage = function () {
                let app = AppData.getAppByCode(AppCode.WEBSITE_APP);
                let allowChooseHrAppAttribute = app.getAppAttribute(AppCode.WEBSITE_ATTRIBUTE_ALLOW_CHOOSE_HR);
                if (allowChooseHrAppAttribute && allowChooseHrAppAttribute.value === "false") {
                    return gettextCatalog.getString("Pour information lors d'une réservation sur {{partnerName}} votre client pourra choisir son professionnel, contrairement à ce que vous avez paramétré sur votre site internet {{brandLabel}}.",
                        {partnerName: BasicAuthRole.LE_CISEAU_ROLE.label, brandLabel: Brand.label});
                }
            };

            storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].displaySubscription = function (companyView, subscriptionView) {
                return companyView.country === Countries.FRANCE.countryCode && BasicAuthRole.LE_CISEAU_ROLE.isCompanyTypeCompliant(companyView);
            };

            storeAppCodeObjects[StoreAppCode.OPTION_WITHOUT_TILL_STORE_APP_CODE].displaySubscription = function (companyView, subscriptionView) {
                return OfferManager.isWithoutTillCompatibleWithActiveOffer(companyView);
            };

            storeAppCodeObjects[StoreAppCode.OPTION_ICAL_APP_CODE].displaySubscription = function (companyView, subscriptionView) {
                return subscriptionView && subscriptionView.isActive;
            };

            storeAppCodeObjects[StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE].disableSubscription = function (offerCode) {
                return offerCode === Offers.ATTRACT.code;
            };

            storeAppCodeFactory = {
                storeAppCodeObjects: storeAppCodeObjects,
                from: function (storeAppCode) {
                    for (let storeAppCodeObject in this.storeAppCodeObjects) {
                        if (storeAppCodeObjects.hasOwnProperty(storeAppCodeObject) && storeAppCode === storeAppCodeObjects[storeAppCodeObject].code) {
                            return storeAppCodeObjects[storeAppCodeObject];
                        }
                    }
                    return null;
                }
            };
            return storeAppCodeFactory;
        }]);



// WEBPACK FOOTER //
// ./js/services/views/StoreAppConstants.js